import { useAuthContext } from "../utils/hooks/useAuthContext";
import React, { ReactElement } from "react";
import { ROUTES } from "../utils/constants";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasBeenChecked, hasError, isOnline } from "../store/site/selectors";
import Loading from "../ui/pages/Loading";
import Maintenance from "../ui/pages/Maintenance";
import { Home } from "../ui/pages";
import TemporaryHome from "../ui/pages/TemporaryHome";
import Layout from "../ui/molecules/Layout";

export default function WrapperRoute(): ReactElement {
  const isSiteOnline = useSelector(isOnline);
  const isSiteHasError = useSelector(hasError);
  const isSiteChecked = useSelector(hasBeenChecked);

  if (!isSiteChecked) {
    return <Loading />;
  } else if (isSiteHasError) {
    return <Maintenance />;
  } else {
    return isSiteOnline ? (
      <Layout>
        <Outlet />
      </Layout>
    ) : (
      <TemporaryHome />
    );
  }
}
